// ** Toolkit imports
import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import storage from "redux-persist/lib/storage"
import { persistStore, persistReducer } from "redux-persist"

// ** Reducers
import app from './app';
import auth from './auth';
import asset from './asset';
import category from './category';
import faq from './faq';
import request from './request';
import review from './review';
import user from './user';
import terms from './terms';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'app']
}

const rootReducer = combineReducers({
  app,
  auth,
  asset,
  category,
  faq,
  request,
  review,
  user,
  terms
})

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
})

const persistor = persistStore(store);

export { store, persistor }